/**
 * 【KYMW5002】画像情報詳細取得VO
 *
 * @export GetImageInfoDetailModel
 * @class GetImageInfoDetailModel
 */
export class GetImageInfoDetailModel {
  /** 画像ID  */
  public imageId = String('');
}
